<template>
	<div id="product">
		<div class="product_banner">
			<div class="banner_intro"><span class="max">安宣A3</span>－ 一款专属于智慧农贸市场的追溯电子秤</div>
			<div class="bannerBody">
				<div class="banner_points" v-for="(item,index) in banner_points" :class="[item.class,item.shows?'active':'']">
					<div class="banner_pointShine" @mousemove="showst(item)" @mouseleave="showsf(item)"></div>
					<div class="banner_point"></div>
					<div class="banner_detail">
						<h4>{{item.point}}</h4>
						<h5>{{item.detail}}</h5>
					</div>
				</div>
			</div>

		</div>
		<div class="product_software">
			<div class="product_software_title">软件产品</div>
			<div class="product_software_content">
				<div class="product_software_list" v-for="(item,index) in software_newArray">
					<div class="product_software_listBox">
						<div v-for="(item_,index) in software_newArray[index]" @click="get_softIntro(item_,$event)" class="product_software_listOne" :class="{ product_software_listOne_click: item_.isSelect }" @mousemove="hoverSoftIcon(item_)" @mouseleave="leaveSoftIcon(item_)">
							<div class="product_software_listImg">
								<img :src="item_.img_hover" v-show="item_.isSelect">
								<img :src="item_.img" v-show="!item_.isSelect">
							</div>
							<div class="product_software_listName" :class="{ product_software_listName_click: item_.isSelect }">{{item_.name}}</div>
						</div>
					</div>
					<div class="product_software_listIntro" v-show="intro_index==index">
						<div>{{intro_text}}</div>
					</div>
				</div>
			</div>
		</div>
		<div class="product_hardware">
			<div class="product_hardware_title">智能硬件</div>
			<div class="product_hardware_lists">
				<div class="product_hardware_list" v-for="(item,index) in hardware">
					<img class="product_hardware_listImg" v-lazy="item.img">
					<div class="product_hardware_listContent">
						<div class="product_hardware_listTitle">{{item.name}}</div>
						<div class="product_hardware_features">
							<div class="product_hardware_feature" v-for="item_ in item.features">
								<img class="product_hardware_featureIcon" :src="item_.icon" @mouseover="hoverHardIcon(item_)" @mouseleave="leaveHardIcon(item_)"> {{item_.name}}
							</div>
						</div>
						<div class="product_hardware_listIntro">{{item.intro}}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		metaInfo() {
			return {
				meta: [{
						name: 'product',
						content: 'http://www.ax168.com/product'
					},
					{
						name: 'product',
						content: '产品服务。食品追溯系统、食品检测系统、市场运营系统、商家管理系统、会员营销系统、网上菜场系统、市场招商系统、电子结算系统、智能巡查系统、数据展示系统、智慧农场系统、智慧禽畜系统、智慧水产系统'
					},
					{
						name: 'keywords',
						content: '智慧农贸,智慧市场，智慧菜场，电子追溯，电子支付，智慧农贸,数字农贸,智慧农贸市场,智慧城市,菜篮子,农贸市场管理,农贸市场管理系统,溯源单子秤,智慧菜场,智慧菜市场,智慧市场,农贸市场智慧化建设方案,智慧微菜场,农贸市场管理软件,智慧农贸电子秤,农贸市场管理软件,菜市场管理系统,菜市场管理软件,新型农贸市场,O2O菜场，重要产品追溯系统,智慧农贸信息化平台,食品追溯监管系统,企业产品追溯系统,农产品追溯系统,仓储配送系统,智慧支付系统'
					},
					{
						name: 'description',
						content: '浙江安宣信息技术有限公司，国家高新技术企业，咨询热线0571-87357305，智慧菜场、智慧农贸、智慧农批、智慧市场、食品安全信息化监管和食品安全追溯平台以及农贸O2O电商平台。'
					}
				]
			}
		},
		data() {
			return {
				i: 0, //显示索引
				banner_points: [{
						point: '计重',
						detail: '常规称重功能，最大称量30KG。',
						class: 'banner_point1',
						shows: false
					},
					{
						point: '计件',
						detail: '无需称重的预包装产品可使用计件功能。',
						class: 'banner_point2',
						shows: false
					},
					{
						point: '计价',
						detail: '支持通过按键指令预设单品价格，也可以数字键直接输入价格。',
						class: 'banner_point3',
						shows: false
					},
					{
						point: '防水',
						detail: '秤体全密封，关键模块置于表头，水产摊位也可放心使用。',
						class: 'banner_point4',
						shows: false
					},
					{
						point: '防断电',
						detail: '6600MA锂电池，断电情况下可正常工作48小时。',
						class: 'banner_point5',
						shows: false
					},
					{
						point: '防作弊',
						detail: '防破解内部程序，如遇恶意破解立即报警。',
						class: 'banner_point6',
						shows: false
					},
					{
						point: '能通讯',
						detail: '内置WIFI网络模块，实行互联网通讯。',
						class: 'banner_point7',
						shows: false
					},
					{
						point: '能支付',
						detail: '支持微信、支付宝、银行聚合码等多种支付方式。',
						class: 'banner_point8',
						shows: false
					},
					{
						point: '能播报',
						detail: '内置语音模块，支持支付成功等语音播报。',
						class: 'banner_point9',
						shows: false
					},
					{
						point: '能追溯',
						detail: '40*3页快捷键支持按键与经营品种关联，实现产品追溯。',
						class: 'banner_point10',
						shows: false
					},
				],
				software: [{
						name: "食品追溯系统",
						isHover: true,
						isSelect: true,
						img: 'http://img.anxuan360.com/Fro61Ub3e4v5K4JRdLjfMl95eGQJ',
						img_normal: 'http://img.anxuan360.com/Fro61Ub3e4v5K4JRdLjfMl95eGQJ',
						img_hover: 'http://img.anxuan360.com/FvND7iQWOO0nVynG6r5FnBaY5Lia',
						intro: "食品安全追溯系统在食品供应链中提供完全透明的管理能力，保障食品安全全程可视化控制、监控与追溯，可以全程监控食品生产、加工过程的添加剂以及有害物质、流通环节中的安全隐患。对有可能出现的食品安全隐患进行有效评估和科学预警提供依据。数据能够通过网络实现实时、准确报送，便于快速高效做更深层次的分析研究。消费者可查询所购买食品的完整追踪信息。",
					},
					{
						name: "食品检测系统",
						isHover: false,
						isSelect: false,
						img: 'http://img.anxuan360.com/FuXWpFon43dRo-AzezW_wXsZ4f_i',
						img_normal: 'http://img.anxuan360.com/FuXWpFon43dRo-AzezW_wXsZ4f_i',
						img_hover: 'http://img.anxuan360.com/FiZOitKJuPOGGy8KFWIMEGaMFcYG',
						intro: "食品检测系统基于物联网技术研发设计。食品检测数据将自动上传至监管平台，极大的提高了工作人员的效率，检测结果更加透明可信，对检测不合格产品实现自动预警，同时消费者可以通过公众监管平台查询检测数据。",
					},
					{
						name: "市场管理系统",
						isHover: false,
						isSelect: false,
						img: 'http://img.anxuan360.com/Fm-82zf0VD9UEW20xKrwIDw0FHyx',
						img_normal: 'http://img.anxuan360.com/Fm-82zf0VD9UEW20xKrwIDw0FHyx',
						img_hover: 'http://img.anxuan360.com/FmNZDv1Vjjyadf4lR8xwXyP1dZ2s',
						intro: '市场管理系统运用物联网技术，采集交易数据，通过“一云多端”智慧系统，实现农贸市场管理、服务和监管的信息网络化、工作规范化、管理现代化；系统利用先进的信息化手段，在实现关注食品安全，保护消费者权益、方便消费购物的同时，提升了市场管理水平，其具有针对性定制的功能模块，充分实现了信息的实时化、具体化、可视化，极大地方便了市场和相关职能部门对市场经营活动的动态监管。',
					},
					{
						name: "商家管理系统",
						isHover: false,
						isSelect: false,
						img: 'http://img.anxuan360.com/FkFcygysgWGPlh8nWjIhMe794c9u',
						img_normal: 'http://img.anxuan360.com/FkFcygysgWGPlh8nWjIhMe794c9u',
						img_hover: 'http://img.anxuan360.com/FiOj_UtWUPF3qs4DCkEMIVy8G32N',
						intro: "商家管理系统基于对仓库和财务的管理，实现通过对商品信息的管理及时更新，实现电子秤、网上菜场与后台之间的无缝链接，实现对商品，供应商，客户基本信息的管理，能够及时了解客户的消费状况；通过对财务的管理了解商品销售情况以及资金流通状况，合理利用资金。",
					},
					{
						name: "会员营销系统",
						isHover: false,
						isSelect: false,
						img: 'http://img.anxuan360.com/Fo857G0xZJNJMR2dR0a-l-IirlcQ',
						img_normal: 'http://img.anxuan360.com/Fo857G0xZJNJMR2dR0a-l-IirlcQ',
						img_hover: 'http://img.anxuan360.com/Fgq3-XZJsDwv0LDs2Oaf5Wb9UOBF',
						intro: "会员管理系统包含会员管理系统、卡管理系统及商家营销管理三部分服务，是一个专门针对分布式多服务网点和单网点而设计的实时会员系统。会员卡管理系统集成了商户管理、会员管理、会员卡管理、会员积分管理、会员卡账管理、财务清算、会员制营销等功能于一体，商户可通过独立研发的读卡器、手持无线会员机、射频读卡器、条码扫描器等多种终端形式提供会员一卡通系统服务(会员卡、会员储值卡、会员积分卡、打折卡、体验卡等)",
					},
					{
						name: "网上菜场系统",
						isHover: false,
						isSelect: false,
						img: 'http://img.anxuan360.com/FkmF6JHhxIuggud9_eHy1TPeE20v',
						img_normal: 'http://img.anxuan360.com/FkmF6JHhxIuggud9_eHy1TPeE20v',
						img_hover: 'http://img.anxuan360.com/FjakOXmda_rNbQ1Iaml5fvwgK3eQ',
						intro: "网上菜场，就是一个农贸市场互联网化的购菜平台，他所提供的商品是家庭里一日三餐所需要的相关菜蔬肉油等食品，并提供相应的免费配送服务，与一般老百姓走得更近。老百姓可以足不出户，在家轻点电脑键盘或者手机上即能购买到餐桌上的菜品，这一举措大大方便了那些上班早出晚归没时间上菜场或离菜场较远的居民，解决了居民生活的后顾之忧，方便了那些上班早出晚归没时间上菜场或离菜场较远的居民。",
					},
					{
						name: "市场招商系统",
						isHover: false,
						isSelect: false,
						img: 'http://img.anxuan360.com/Frm-GF8Mj95LtIxfCercSQhHz3Cr',
						img_normal: 'http://img.anxuan360.com/Frm-GF8Mj95LtIxfCercSQhHz3Cr',
						img_hover: 'http://img.anxuan360.com/Fty85MO7U3EzSidMKBN9ZTNSkMyT',
						intro: "市场招商系统是为农贸市场、农批市场、摊主提供一站式服务平台，服务包括：摊位转让、摊位租售、市场招租、求租摊位、求购摊位，并提供经营数据指导。",
					},
					{
						name: "电子结算系统",
						isHover: false,
						isSelect: false,
						img: 'http://img.anxuan360.com/FpANHOOkTRzVMWGhQS5-3HxDVXDh',
						img_normal: 'http://img.anxuan360.com/FpANHOOkTRzVMWGhQS5-3HxDVXDh',
						img_hover: 'http://img.anxuan360.com/FjYOuiSWXu-THXh8Vqcq_s58M7k_',
						intro: "电子结算系统帮助农贸市场、网上农贸市场提供了一整套完整的资金管理解决方案，帮各商家和市场方一站式解决资金存管、支付、二清、税务、资金安全、监管合法等问题。",
					},
					{
						name: "智能巡查系统",
						isHover: false,
						isSelect: false,
						img: 'http://img.anxuan360.com/FlUdrNrQ7U_GwacVqZB9_xSXOtiL',
						img_normal: 'http://img.anxuan360.com/FlUdrNrQ7U_GwacVqZB9_xSXOtiL',
						img_hover: 'http://img.anxuan360.com/FqFkIE7Nn79ZXQ9gaOHgwQbEkGmA',
						intro: "利用互联网云技术构建信息化管理平台，实现资源共享，提供政府、企业巡检管理工作的科技化水平，提高巡检部门的内部管理水平，解决人员巡检不到位，隐患上报不及时，数据统计不完整等巡检难题，巡检信息永久保存，可供领导层随时查阅，为管理者提供有效的巡检数据，提高日常人员的管理水平，弥补传统管理的缺陷，解决了传统巡检工作时候复杂的整理统计工作，替代了纸质化的工作，提高了管理效率。",
					},
					{
						name: "数据展示系统",
						isHover: false,
						isSelect: false,
						img: 'http://img.anxuan360.com/FhbpB-AqaN-ewh_6_QXSlMCtrAj4',
						img_normal: 'http://img.anxuan360.com/FhbpB-AqaN-ewh_6_QXSlMCtrAj4',
						img_hover: 'http://img.anxuan360.com/FszqHyOs47hsF3oHqu6DM25e3tzH',
						intro: "数据展现系统提供查询、报表、监控、预警、分析和挖掘等各种农贸市场和食品安全等相关的数据服务，以此为基础可以快速构建面向政府、农贸市场、商家和消费者等各层面的数据分析应用系统。",
					},
				],
				software_newArray: [],
				intro_index: 0,
				intro_text: '',
				hardware: [{
					name: '智能显示屏',
					features: [{
							icon: 'http://img.anxuan360.com/FoC0asvZxdJN_z_SeP8G2F4vfBvr',
							icon_n: 'http://img.anxuan360.com/FoC0asvZxdJN_z_SeP8G2F4vfBvr',
							icon_h: 'http://img.anxuan360.com/FshmoOsCtL1J31ZPkkn1s99iXh74',
							name: '智能'
						},
						{
							icon: 'http://img.anxuan360.com/Fq0tTTORVrQm42_xaZbHmvhWfvn8',
							icon_n: 'http://img.anxuan360.com/Fq0tTTORVrQm42_xaZbHmvhWfvn8',
							icon_h: 'http://img.anxuan360.com/Fpbj9i6gyVidFXhj-NASY5yRtJDM',
							name: '数据分析'
						},
						{
							icon: 'http://img.anxuan360.com/FgrhanCaiC-W-zzPTtM3Q1Q87nuO',
							icon_n: 'http://img.anxuan360.com/FgrhanCaiC-W-zzPTtM3Q1Q87nuO',
							icon_h: 'http://img.anxuan360.com/FkpRHc8wJiLgusgJzRIX1rr5cxwH',
							name: '可视化'
						},
					],
					intro: '根据市场需求，提供市场大屏、商户小屏、共享小屏等多种高性价比的信息展示解决方案，实现市场检测信息、追溯信息、价格信息、交易信息、商户信息、检查信息的实时动态展示。',
					img: 'http://img.anxuan360.com/Fvy8N-AqQ1psBgKEinMqxt1QYk0K',
				}, {
					name: '智能追溯秤',
					features: [{
							icon: 'http://img.anxuan360.com/FirFhcvcUPwXrR-f1INkraycfqHW',
							icon_n: 'http://img.anxuan360.com/FirFhcvcUPwXrR-f1INkraycfqHW',
							icon_h: 'http://img.anxuan360.com/FmTqFULnyG591Uo4lDpQwfl_4fTS',
							name: '防水'
						},
						{
							icon: 'http://img.anxuan360.com/FqeXanWODnTsoMR1HFFxVeIIuLYs',
							icon_n: 'http://img.anxuan360.com/FqeXanWODnTsoMR1HFFxVeIIuLYs',
							icon_h: 'http://img.anxuan360.com/FlSFAJGQNoVQm0aAEQHwAI516ahw',
							name: '续航'
						}, {
							icon: 'http://img.anxuan360.com/Fq45hMax2RKlEzId-umYoicMSpoF',
							icon_n: 'http://img.anxuan360.com/Fq45hMax2RKlEzId-umYoicMSpoF',
							icon_h: 'http://img.anxuan360.com/FoWsNCSrTgafVF5X-t-wdvpyzDH6',
							name: '语音播报'
						},
					],
					intro: '安宣智能追溯秤针对农贸市场的应用场景专门设计，不仅具有传统电子秤的计重、计件、计价等基本功能，突出了防水（水产摊位可放心使用）、防断电（断电可使用48小时）、防作弊（如有作弊立即报警）等特色功能，同时还具有能通信、能播报、能支付、能追溯等高级功能。',
					img: 'http://img.anxuan360.com/Fuj-982_llfdRl2m3NUz04UJucLR',
				}, {
					name: '查询一体机',
					features: [{
							icon: 'http://img.anxuan360.com/FsC0Kgyud5PaeWpKDJgI4o2UPZEl',
							icon_n: 'http://img.anxuan360.com/FsC0Kgyud5PaeWpKDJgI4o2UPZEl',
							icon_h: 'http://img.anxuan360.com/Fmi9XdirxUJJKTxwBjmaJmwx5p4X',
							name: '易操作'
						},
						{
							icon: 'http://img.anxuan360.com/Fst75Xl9xj7hAa9GR9s3fNFg9IKd',
							icon_n: 'http://img.anxuan360.com/Fst75Xl9xj7hAa9GR9s3fNFg9IKd',
							icon_h: 'http://img.anxuan360.com/FkghLDqKTXQELvb_b7UreN0lhBlS',
							name: '人性化'
						},
						{
							icon: 'http://img.anxuan360.com/Fv5qW7ol_MsP5BFNVRmFPPZNG_U0',
							icon_n: 'http://img.anxuan360.com/Fv5qW7ol_MsP5BFNVRmFPPZNG_U0',
							icon_h: 'http://img.anxuan360.com/FjtR4UkiGbN6a8fF1xv8j6hkdhFt',
							name: '反应快'
						},
					],
					intro: '查询机有立式、卧式等多种型号，设置了市场风貌、商家风采、检测公示、追溯查询、今日菜价等模块与消费者实现信息互动。',
					img: 'http://img.anxuan360.com/FuztXD2St20rXvaMJ06qyKszmcQM',
				}, ]
			}
		},
		mounted: function() {

			this.myVar = setInterval(this.myTimer, 3500);
			//整理软件数组为二维数组方便页面渲染
			var software_rows = Math.ceil(this.software.length / 4);
			for(var i = 0; i < software_rows; i++) {
				this.software_newArray.push([]);
				for(var j = 0; j < this.software.length; j++) {
					if(j - i * 4 >= 0 && j - i * 4 < 4) { //每列为4个元素          
						this.software_newArray[i].push(this.software[j]);
					} else {
						continue
					}
				}
			}
			this.soft_intro();
		},
		activated() {
			document.documentElement.style.fontSize = "";
		},
		methods: {
			//所有动画隐藏
			addhide() {
				for(var j = 0; j < this.banner_points.length; j++) {
					this.banner_points[j].shows = false
				}
			},
			myTimer() {
				this.addhide()
				this.banner_points[this.i].shows = true
				this.i++
					if(this.i == this.banner_points.length) {
						this.i = 0
					}
			},
			showst(item) {
				this.addhide()
				item.shows = true
				clearInterval(this.myVar);
			},
			showsf(item) {
				item.shows = false
				this.myVar = setInterval(this.myTimer, 3500)
			},
			// 判断展示哪一列的软件介绍
			soft_intro: function() {
				for(var i = 0; i < this.software_newArray.length; i++) {
					for(var j = 0; j < this.software_newArray[i].length; j++) {
						if(this.software_newArray[i][j].isSelect) {
							this.intro_index = i;
							this.intro_text = this.software_newArray[i][j].intro;
						}
					}
				}
			},
			// 获取软件介绍信息
			get_softIntro: function(item, self) {
				this.intro_text = item.intro;
				for(var i = 0; i < this.software_newArray.length; i++) {
					for(var j = 0; j < this.software_newArray[i].length; j++) {
						this.software_newArray[i][j].isSelect = false;
					}
				}
				item.isSelect = true;
				for(var i = 0; i < this.software_newArray.length; i++) {
					for(var j = 0; j < this.software_newArray[i].length; j++) {
						if(this.software_newArray[i][j].isSelect) {
							this.intro_index = i;
						}
					}
				}
			},
			// 软件产品 hover状态换图片
			hoverSoftIcon: function(item) {
				item.img = item.img_hover
			},
			leaveSoftIcon: function(item) {
				item.img = item.img_normal
			},
			// 硬件产品 hover状态换图片
			hoverHardIcon: function(item) {
				item.icon = item.icon_h;
			},
			leaveHardIcon: function(item) {
				item.icon = item.icon_n;
			}
		},
		components: {

		}
	}
</script>

<style>
	@import url('../css/product.css');
	#product .product_banner .bannerBody {
		position: absolute;
		top: 22%;
		left: 35%;
		height: 432px;
		width: 651px;
		background: url('http://img.anxuan360.com/FoLT8u7QcHZZ0SLCraiI_vnVuade') no-repeat 50%;
	}
	
	#product .product_banner .banner_intro {
		position: absolute;
		top: 12%;
		left: 15%;
		font-size: 20px;
		color: #ffffff;
		width: 36px;
		text-align: center;
	}
	
	#product .product_banner .banner_points {
		position: absolute;
		top: 200px;
		left: 200px;
	}
	
	#product .product_banner .banner_points .banner_point {
		width: 15px;
		height: 15px;
		border-radius: 100%;
		background: #00c59f;
	}
	
	#product .product_banner .banner_points .banner_pointShine {
		content: '';
		position: absolute;
		top: -18px;
		left: -17px;
		background: #00c59f;
		opacity: 0.45;
		border-radius: 100%;
		width: 50px;
		height: 50px;
		display: block;
		z-index: 9999;
		animation: pulsate 2s cubic-bezier(0.2, 1, 0.2, 1) infinite;
		outline: none;
	}
	
	@-webkit-keyframes pulsate {
		from {
			opacity: 1;
			transform: scale(1);
		}
		to {
			opacity: 0;
			transform: scale(2);
		}
	}
	
	#product .product_banner .banner_points .banner_detail {
		position: absolute;
		left: -280px;
		top: -50px;
		width: 184px;
		opacity: 0;
		color: #ffffff;
		background: #00c59f;
		padding: 16px 18px;
		z-index: 9999;
		pointer-events: none;
		border-radius: 3px;
		transition: all 1s;
	}
	
	#product .product_banner .banner_points.active .banner_detail {
		opacity: 1;
		left: -250px;
	}
	
	#product .product_banner .banner_point7.active .banner_detail {
		opacity: 1;
		left: 80px;
	}
	
	#product .product_banner .banner_point8.active .banner_detail {
		opacity: 1;
		left: 80px;
	}
	
	#product .product_banner .banner_point9.active .banner_detail {
		opacity: 1;
		left: 80px;
	}
	
	#product .product_banner .banner_point10.active .banner_detail {
		opacity: 1;
		left: 80px;
	}
	
	#product .product_banner .banner_points .banner_detail h4 {
		font-size: 18px;
		font-weight: bold;
		margin-bottom: 15px;
	}
	
	#product .product_banner .banner_points .banner_detail h5 {
		font-size: 14px;
		font-weight: normal;
		line-height: 20px;
	}
	/* 计重 */
	
	#product .product_banner .banner_point1 {
		top: 48%;
		left: 15%;
		z-index: 99;
	}
	/* 计件 */
	
	#product .product_banner .banner_point2 {
		top: 65%;
		left: 6%;
	}
	/* 计价 */
	
	#product .product_banner .banner_point3 {
		top: -1%;
		left: 17%;
		z-index: 99;
	}
	/* 防水 */
	
	#product .product_banner .banner_point4 {
		top: 10%;
		left: 38%;
	}
	/* 防电 */
	
	#product .product_banner .banner_point5 {
		top: 48%;
		left: 45%;
	}
	/* 防作弊 */
	
	#product .product_banner .banner_point6 {
		top: 28%;
		left: 39%;
	}
	/* 能通讯 */
	
	#product .product_banner .banner_point7 {
		top: 11%;
		left: 92%;
	}
	/* 能播报 */
	
	#product .product_banner .banner_point7 .banner_detail {
		left: 50px;
	}
	
	#product .product_banner .banner_point8 {
		top: 55%;
		left: 80%;
	}
	
	#product .product_banner .banner_point8 .banner_detail {
		left: 50px;
	}
	/* 能支付 */
	
	#product .product_banner .banner_point9 {
		top: 33%;
		left: 96%;
	}
	
	#product .product_banner .banner_point9 .banner_detail {
		left: 50px;
	}
	/* 能追溯 */
	
	#product .product_banner .banner_point10 {
		top: 0%;
		left: 50%;
	}
	
	#product .product_banner .banner_point10 .banner_detail {
		left: 50px;
	}
</style>


// WEBPACK FOOTER //
// src/components/product.vue